import React from 'react';
import { REGIONS, getRegionLabel } from '../lib/regions';

export function RegionTabBar({ value, onChange }) {
  const labelText = value === 'all' ? 'All regions' : getRegionLabel(value);
  const cls = (active) => `rounded-md px-3 py-1.5 border-2 border-black text-sm font-sans font-semibold transition-all ${active ? 'bg-[#ffd703] shadow-[3px_3px_0px_#000]' : 'bg-white hover:bg-[#fef9e7]'}`;
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-2">
        <span className="text-sm font-sans font-semibold text-black">Dashboard:</span>
        <span className="text-xs text-black/60 font-sans" data-testid="active-region-label">{labelText}</span>
      </div>
      <div className="flex flex-wrap gap-2" data-testid="region-tabs">
        <button
          type="button"
          onClick={() => onChange('all')}
          className={cls(value === 'all')}
          data-testid="region-tab-all"
        >
          All Regions
        </button>
        {REGIONS.map(r => (
          <button
            key={r.value}
            type="button"
            onClick={() => onChange(r.value)}
            className={cls(value === r.value)}
            data-testid={`region-tab-${r.value}`}
          >
            {r.label}
          </button>
        ))}
      </div>
    </div>
  );
}
